<template>
  <div :class="!isMobile ? 'mt-2 ml-2' : ''">
    <v-toolbar dense class="colorDominant my-1">
      <div class="d-flex justify-space-between flex-grow-1">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <GridOrlistOdds />
      </div>
    </v-toolbar>
    <v-img
      :height="$vuetify.breakpoint.mdAndUp ? 240 : 120"
      src="https://dozr8la71aog.cloudfront.net/images/event/bbboficial2.jpg"
      position="center center"
    />
    <v-tabs
      :class="{
        'px-0': $vuetify.breakpoint.smAndUp,
      }"
      background-color="colorDominant colorTabs"
    >
      <v-tab class="white--text text-capitalize">
        {{ $t("finalWinner") }}
      </v-tab>
    </v-tabs>
    <v-card class="colorDominant" :class="loading ? 'py-2' : ''">
      <v-card-text class="pa-0">
        <div v-if="canSafelyShowOdds">
          <template v-for="(market, a) in dataEvents.odds.markets">
            <div :key="a" v-if="market">
              <div
                class="py-3 align-center px-4 d-flex"
                style="background: rgba(0, 0, 0, 0.25)"
                :v-if="market.hide_market"
              >
                <div class="subtitle-2 text--secondary text-truncate">
                  {{ market.name_market }}
                </div>
                <div class="flex-grow-1"></div>
              </div>
              <div
                :class="
                  'd-flex flex-wrap justify-space-between ' + styleFormatOdd
                "
              >
                <div
                  v-for="odd in market.odds"
                  :key="odd.id_odd"
                  :v-if="odd.hide_odd"
                  class="flex-grow-1"
                  style="margin-bottom: 1px"
                  :style="styleFormatOdd == 'flex-row' ? 'width: 30%;' : ''"
                >
                  <div
                    class="
                    pa-3
                    worldCupWinnerOdd
                    odd odd-live
                    d-flex
                    justify-space-between
                    fill-height
                    subtitle-2
                    align-self-stretch
                  "
                    :class="[
                      odd.blocked
                        ? 'grey--text v-card--disabled'
                        : 'cursor-pointer oddActive white--text',
                      {
                        colorOddSelectedTheme: coupons.some(
                          (item) => item.id_odd == odd.id_odd
                        ),
                        odd_increased: odd.classAni == 'odd_increased',
                        odd_decreased: odd.classAni == 'odd_decreased',
                      },
                    ]"
                    v-on:click="
                      $selectOdd({
                        id_event: dataEvents.event.id_match,
                        id_odd: odd.id_odd,
                        description: dataEvents.event.description,
                        data: odd,
                      })
                    "
                  >
                    <div class="caption">{{ odd.name_odd }}</div>
                    <div>
                      <v-icon class="px-2" v-if="odd.blocked" size="14">
                        mdi-lock
                      </v-icon>
                      <div
                        v-else
                        class="pl-2 colorOddText--text"
                        :ref="odd.id_odd"
                        :class="odd.id_odd"
                      >
                        {{ odd.odd_price }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <v-alert
          class="mx-4 my-2"
          text
          dense
          type="info"
          border="left"
          v-else-if="loading"
        >
          {{ $t("loading") }}
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import GridOrlistOdds from "@/components/breadcrumbs/gridOrlistOdds.vue";
import rulesOdds from "@/mixins/rulesOdds";

export default {
  name: "worldCupWinner",
  mixins: [rulesOdds],
  components: {
    GridOrlistOdds,
  },
  data: () => ({
    loading: false,
    dataEvents: {},
    msgError: "",
    srcImg: "../../../assets/Banner/banner-world-cup.png",
  }),
  computed: {
    canSafelyShowOdds() {
      return Object.keys(this.dataEvents).length > 0;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    styleFormatOdd() {
      return this.$store.state.styleFlexWrapOdds;
    },
    coupons() {
      return this.$store.getters.getCoupons;
    },
  },
  methods: {
    treatMarket(data) {
      const results = this.$store.getters.getResults;
      // MARKETS
      for (let market of data.odds.markets) {
        // Market = Incluindo Name_market and hide_market
        const markets = this.$store.getters.getMarkets;
        const marketFilter = markets.find(
          (item) => item.id_market == market.id_market
        );
        market.name_market = marketFilter ? marketFilter.name_market : "";
        market.hide_market = marketFilter.active == 0 ? true : false;

        // ODDS
        for (let odd of market.odds) {
          // Odd = Incluindo Name_odd and hide_odd
          const result = results.find(
            (item) => item.id_outcome == odd.id_outcome
          );
          odd.name_odd = result ? result.name_outcome : "";
          odd.hide_odd = result.active == 0 ? true : false;

          // Aplicando a Margem na ODD;
          odd = this.$treatOdd(odd);
        }
      }
      return data;
    },
    request(url, data) {
      this.loading = true;

      this.$axios
        .post(url, this.$formdata(data))
        .then((resp) => {
          this.dataEvents = this.treatMarket(resp.data);
          this.msgError = false; // reset
        })
        .catch((error) => {
          this.msgError = error.response.data.messages["error"];
          const msg = this.msgError;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },
    getDataWorldCup() {
      const url = "tableMain/event";
      const data = {
        domain: this.$domain(),
        id_event: 152150,
      };
      this.request(url, data);
    },
  },
  mounted() {
    this.getDataWorldCup();
  },
};
</script>
<style>
.worldCupWinnerOdd {
  border-radius: 0px !important;
  margin: 0px 0 0px 1px;
}
</style>
